import React, { useState, useEffect } from 'react';
import axiosInstance from '../axiosConfig';
import Header from '../Components/Header';
import Sidebar from '../Components/Sidebar';
import '../styles.css';

const LeaveBalance = () => {
  const [userData, setUserData] = useState(null);
  const [data, setData] = useState({});
  const [leaveBalance, setLeaveBalance] = useState(null);

  const [loading, setLoading] = useState(true);

  const currentUserId = localStorage.getItem('id');
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [isIdCardPopupVisible, setIsIdCardPopupVisible] = useState(false);

  useEffect(() => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 520) {
      setIsSidebarVisible(false);
    } else {
      setIsSidebarVisible(true);
    }
  }, []);

  const handleToggleClick = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  useEffect(() => {
    if (currentUserId) {
      axiosInstance.get(`/user/${currentUserId}/`)
        .then((response) => setUserData(response.data))
        .catch((error) => console.error('Error fetching user data:', error));
    }
  }, [currentUserId]);

  useEffect(() => {
    if (currentUserId) {
      setLoading(true);
      Promise.all([
        axiosInstance.get(`/user/${currentUserId}/`),
        axiosInstance.get('/leave-balance/')
      ]).then(([userRes, balanceRes]) => {
        setUserData(userRes.data);
        setData(balanceRes.data);
        setLeaveBalance(balanceRes.data);
        setLoading(false);
      }).catch((error) => {

        console.error(error);
        setLoading(false);
      });
    }
  }, [currentUserId]);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  const profilePhotoUrl = userData?.profile_photo?.startsWith('http://') 
    ? userData?.profile_photo.replace('http://', 'https://') 
    : userData?.profile_photo;

  const menuItems = [
    { icon: '🏠', label: 'Dashboard', path: '/user-dashboard' },
    { icon: '👤', label: 'My Profile', path: `/user-profile/${userData?.id}` },
    { icon: '📅', label: 'Attendance', path: `/leave-attendance/${userData?.id}` },
    { icon: '📋', label: 'Leave Management', path: `/leave-management/${userData?.id}` },
    { icon: '✏️', label: 'Create Leave Request', path: `/leave-request/${userData?.id}` },
    { icon: '💰', label: 'Leave Balance', path: '/leave-balance' },
    { icon: '📊', label: 'Leave Transactions', path: '/leave-transaction/' },
    // { icon: '📅', label: 'Calendar', path: '/calendar' },
    // { icon: '&#128178;', label: 'Payroll', path: 'https://hrms.teamhalt.com/', active: false },
    { icon: '🆔', label: 'ID Card', action: () => setIsIdCardPopupVisible(true) },
  ];

  return (
    <div className={`dashboard-wrapper ${isSidebarVisible ? 'sidebar-open' : 'sidebar-closed'}`}>
      <Header 
        onToggleClick={handleToggleClick} 
        isSidebarVisible={isSidebarVisible} 
      />
      
      <Sidebar 
        isSidebarVisible={isSidebarVisible}
        currentUser={userData}
        menuItems={menuItems}
        handleLogout={handleLogout}
      />
      
      <div className="dashboard-main-content">
        <div className="leave-balance-container">


          <div className="leave-balance-header">
            <h1>Leave Balance</h1>
            <p>View your leave balance and request history</p>
          </div>

          {loading ? (
            <div className="leave-balance-loading">
              <div className="loading-spinner"></div>
              <p>Loading leave balance...</p>
            </div>
          ) : (
            <div className="leave-balance-content">
              {/* <div className="leave-balance-card">
                <div className="leave-balance-card-header">
                  <span className="card-icon">📋</span>
                  <h3>Leave Requests</h3>
                </div>
                <div className="leave-balance-table-wrapper">
                  <table className="leave-balance-table">
                    <thead>
                      <tr>
                        <th>Leave Type</th>
                        <th>Days</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.leave_requests && data.leave_requests.length > 0 ? (
                        data.leave_requests.map((leaveRequest) => (
                          <tr key={leaveRequest.id}>
                            <td>{leaveRequest.leave_type}</td>
                            <td>{leaveRequest.days}</td>
                            <td>
                              <span className={`status-badge ${leaveRequest.status?.toLowerCase()}`}>
                                {leaveRequest.status}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="no-data">No leave requests found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div> */}

              {/* Current User Leave Balances */}
              <div className="leave-balance-card">
                <div className="leave-balance-card-header">
                  <span className="card-icon">💰</span>
                  <h3>My Current Balances</h3>
                </div>
                <div className="leave-balance-table-wrapper">
                  <table className="leave-balance-table">
                    <thead>
                      <tr>
                        <th>Leave Type</th>
                        <th>Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {leaveBalance?.balances ? (
                        Object.entries(leaveBalance.balances).map(([type, balance]) => (
                          <tr key={type}>
                            <td style={{fontWeight: '600'}}>{type}</td>
                            <td>
                              <span className={`leave-days-badge ${parseFloat(balance) > 0 ? 'positive' : ''}`}>
                                {parseFloat(balance).toFixed(2)} days
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="2" className="no-data">No balances found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Total balance (shown below leave requests section) */}
              <div className="leave-balance-total">
                <p className="leave-balance-total-text">
                  <strong>Your Total Leave Balance:</strong>{' '}
                  {leaveBalance?.total_available !== undefined && leaveBalance?.total_available !== null
                    ? `${parseFloat(leaveBalance.total_available).toFixed(2)} days`
                    : 'N/A'}
                </p>
              </div>


              {/* Leave Policy */}
              {/* <div className="leave-balance-card">
                <div className="leave-balance-card-header">
                  <span className="card-icon">📚</span>
                  <h3>Leave Policy (Max Allowance)</h3>
                </div>
                <div className="leave-balance-table-wrapper">
                  <table className="leave-balance-table">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Annual Allowance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.leave_types && data.leave_types.length > 0 ? (
                        data.leave_types.map((type) => (
                          <tr key={type.id}>
                            <td>{type.name}</td>
                            <td>{type.days_allowed || 0} days</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="2" className="no-data">No policy data</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div> */}
            </div>
          )}
        </div>
        
        {isIdCardPopupVisible && (
          <div className="id-card-overlay" onClick={() => setIsIdCardPopupVisible(false)}>
            <div className="id-card-popup" onClick={(e) => e.stopPropagation()}>
              <button className="id-card-close" onClick={() => setIsIdCardPopupVisible(false)}>×</button>
              <div className="id-card-header">
                <img src="/Teamhalt.png" alt="Logo" className="id-card-logo" />
                <span>TEAMHALT PRIVATE LIMITED</span>
              </div>
              <div className="id-card-body">
                <div className="id-card-profile">
                  <img src={profilePhotoUrl || '/profile.jpg'} alt="Profile" className="id-card-photo" />
                  <div className="id-card-info">
                    <h4>{userData?.first_name} {userData?.last_name}</h4>
                    <p className="id-designation">{userData?.designation}</p>
                    <div className="id-dob">
                      <strong>DOB:</strong>
                      <span>{userData?.date_of_birth ? new Date(userData.date_of_birth).toLocaleDateString("en-GB").replace(/\//g, "-") : "N/A"}</span>
                    </div>
                  </div>
                </div>
                <hr className="id-card-divider" />
                <div className="id-card-details">
                  {[
                    { label: "Emp ID", value: userData?.employee_code },
                    { label: "Department", value: userData?.department },
                    { label: "ESIC No.", value: userData?.esic_no },
                    { label: "UAN No.", value: userData?.uan_no },
                    { label: "Gender", value: userData?.gender },
                    { label: "Contact No.", value: userData?.contact_number },
                  ].map((item, idx) => (
                    <div key={idx} className="detail-row">
                      <strong>{item.label}:</strong>
                      <span>{item.value || "N/A"}</span>
                    </div>
                  ))}
                </div>
                {typeof userData?.work_location_name === "string" && userData.work_location_name.toLowerCase() !== "noida" && (
                  <div className="id-card-duty">
                    <strong>On Contractual Duty Of:</strong>
                    <span>{userData?.duty_of || "N/A"}</span>
                  </div>
                )}
                <div className="id-card-footer">https://teamhalt.com/</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaveBalance;
